"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DispenserAllowanceButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const react_intl_1 = require("react-intl");
const react_hooks_eth_1 = require("@dzambalaorg/react-hooks-eth");
const types_1 = require("@framework/types");
const approve_json_1 = __importDefault(require("@framework/abis/json/ERC20Simple/approve.json"));
const setApprovalForAll_json_1 = __importDefault(require("@framework/abis/json/ERC1155Simple/setApprovalForAll.json"));
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const dialogs_1 = require("../../../../../../dialogs");
const validation_1 = require("./dialog/validation");
const DispenserAllowanceButton = (props) => {
    const { className } = props;
    const { writeContractAsync } = (0, react_hooks_eth_1.useWriteContractWithSimulation)();
    const { openDialog } = (0, dialogs_1.useGlobalDialogFormCallbacks)();
    const metaFnWithContract = (0, react_hooks_eth_1.useSystemContract)(async (values, systemContract) => {
        const { amount, contract } = values;
        if (contract.contractType === types_1.TokenType.ERC20) {
            return writeContractAsync({
                address: contract.address,
                abi: approve_json_1.default,
                functionName: "approve",
                args: [systemContract.address, amount],
            });
        }
        else if (contract.contractType === types_1.TokenType.ERC721 || contract.contractType === types_1.TokenType.ERC998) {
            return writeContractAsync({
                address: contract.address,
                abi: setApprovalForAll_json_1.default,
                functionName: "setApprovalForAll",
                args: [systemContract.address, true],
            });
        }
        else if (contract.contractType === types_1.TokenType.ERC1155) {
            return writeContractAsync({
                address: contract.address,
                abi: setApprovalForAll_json_1.default,
                functionName: "setApprovalForAll",
                args: [systemContract.address, true],
            });
        }
        else {
            throw new Error("unsupported token type");
        }
    });
    const { execute: metaFn } = (0, react_hooks_eth_1.useMetamask)((values) => {
        return metaFnWithContract(types_1.SystemModuleType.DISPENSER, values);
    });
    const handleAllowanceConfirm = async ({ data }) => {
        await metaFn(data);
    };
    const handleAllowance = () => {
        openDialog(dialogs_1.GlobalDialogKeys.DISPENSER_ALLOWANCE, {}, {
            initialValues: {
                tokenType: types_1.TokenType.ERC20,
                contract: {
                    address: "",
                    contractType: types_1.TokenType.ERC20,
                    decimals: 18,
                },
                contractId: 0,
                amount: "0",
            },
            message: "dialogs.allowance",
            testId: "MechanicsAllowanceForm",
            validationSchema: validation_1.dispenserAllowanceValidationSchema,
            onExternalConfirm: handleAllowanceConfirm,
        });
    };
    return ((0, jsx_runtime_1.jsx)(ui_kit_1.Button, { intent: "secondary", startIcon: (0, jsx_runtime_1.jsx)(icons_material_1.HowToVote, {}), onClick: handleAllowance, className: className, "data-testid": "AllowanceButton", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "form.buttons.allowance" }) }));
};
exports.DispenserAllowanceButton = DispenserAllowanceButton;
//# sourceMappingURL=index.js.map